<!-- <ng-container *ngIf="!isWeb; then assested; else webOnly;"></ng-container>

<ng-template #webOnly>
  <div class="container-full-width" [innerHtml]="coverageMapTag | safeHtml"></div>
</ng-template>

<ng-template #assested>
  <iframe *ngIf="url" [src] ="url | safeUrl" [height]="height" [width]="width"></iframe>
</ng-template> -->
<ng-container>
  <div class="container-full-width" [innerHtml]="coverageMapTag | safeHtml"></div>
</ng-container>
